module.exports = __webpack_public_path__ + "static/media/Down.efb9cc81.svg";